import * as React from "react"
import { type EntityCategory } from "@digits-graphql/frontend/graphql-bearer"
import colors from "@digits-shared/themes/colors"
import { DetailText } from "@digits-shared/themes/typography"
import styled from "styled-components"

const TooltipWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  text-align: left;
`

export const CategoryTooltipContent: React.FC<{
  category?: EntityCategory
  subtext: string
}> = ({ category, subtext }) => {
  if (!category) return null

  return (
    <TooltipWrapper>
      <DetailText color={colors.white} weight="heavy">
        {category.name}
      </DetailText>
      {subtext && <DetailText color={colors.translucentWhite80}>{subtext}</DetailText>}
    </TooltipWrapper>
  )
}
